import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetailsListWidgetService {
  detailslistSubjects: {
    [key: string]: {
      detailslistSearchSubject: BehaviorSubject<string | undefined>,
      detailslistSearch$: Observable<string | undefined>
    }
  } = {
    'ConfirmationContentDetailsList': this.getDetailsListQuestionSubject('ConfirmationContentDetailsList')
  };

  getDetailsListQuestionSubject(detailslistQuestionName: string) {
    const detailslistSearchSubject = new BehaviorSubject<string | undefined>(undefined);
    const detailslistSearch$ = detailslistSearchSubject.asObservable();

    return {
      detailslistSearchSubject,
      detailslistSearch$
    };
  }

  setDetailsListQuestionSubject(detailslistQuestionName: string) {
    this.detailslistSubjects[detailslistQuestionName] = this.getDetailsListQuestionSubject(detailslistQuestionName);
  }
}
